/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Computer';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const ComputerIcon = withMuiAdapter(Base, 'Computer');
